"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowFormatter = void 0;
var FieldFormatter_1 = require("./FieldFormatter");
var types_1 = require("../types");
var RowFormatter = /*#__PURE__*/function () {
  function RowFormatter(formatterOptions) {
    _classCallCheck(this, RowFormatter);
    _defineProperty(this, "formatterOptions", void 0);
    _defineProperty(this, "fieldFormatter", void 0);
    _defineProperty(this, "shouldWriteHeaders", void 0);
    _defineProperty(this, "_rowTransform", void 0);
    _defineProperty(this, "headers", void 0);
    _defineProperty(this, "hasWrittenHeaders", void 0);
    _defineProperty(this, "rowCount", 0);
    this.formatterOptions = formatterOptions;
    this.fieldFormatter = new FieldFormatter_1.FieldFormatter(formatterOptions);
    this.headers = formatterOptions.headers;
    this.shouldWriteHeaders = formatterOptions.shouldWriteHeaders;
    this.hasWrittenHeaders = false;
    if (this.headers !== null) {
      this.fieldFormatter.headers = this.headers;
    }
    if (formatterOptions.transform) {
      this.rowTransform = formatterOptions.transform;
    }
  }
  return _createClass(RowFormatter, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (typeof transformFunction !== 'function') {
        throw new TypeError('The transform should be a function');
      }
      this._rowTransform = RowFormatter.createTransform(transformFunction);
    }
  }, {
    key: "format",
    value: function format(row, cb) {
      var _this = this;
      this.callTransformer(row, function (err, transformedRow) {
        if (err) {
          return cb(err);
        }
        if (!row) {
          return cb(null);
        }
        var rows = [];
        if (transformedRow) {
          var _this$checkHeaders = _this.checkHeaders(transformedRow),
            shouldFormatColumns = _this$checkHeaders.shouldFormatColumns,
            headers = _this$checkHeaders.headers;
          if (_this.shouldWriteHeaders && headers && !_this.hasWrittenHeaders) {
            rows.push(_this.formatColumns(headers, true));
            _this.hasWrittenHeaders = true;
          }
          if (shouldFormatColumns) {
            var columns = _this.gatherColumns(transformedRow);
            rows.push(_this.formatColumns(columns, false));
          }
        }
        return cb(null, rows);
      });
    }
  }, {
    key: "finish",
    value: function finish(cb) {
      var rows = [];
      // check if we should write headers and we didnt get any rows
      if (this.formatterOptions.alwaysWriteHeaders && this.rowCount === 0) {
        if (!this.headers) {
          return cb(new Error('`alwaysWriteHeaders` option is set to true but `headers` option not provided.'));
        }
        rows.push(this.formatColumns(this.headers, true));
      }
      if (this.formatterOptions.includeEndRowDelimiter) {
        rows.push(this.formatterOptions.rowDelimiter);
      }
      return cb(null, rows);
    }
    // check if we need to write header return true if we should also write a row
    // could be false if headers is true and the header row(first item) is passed in
  }, {
    key: "checkHeaders",
    value: function checkHeaders(row) {
      if (this.headers) {
        // either the headers were provided by the user or we have already gathered them.
        return {
          shouldFormatColumns: true,
          headers: this.headers
        };
      }
      var headers = RowFormatter.gatherHeaders(row);
      this.headers = headers;
      this.fieldFormatter.headers = headers;
      if (!this.shouldWriteHeaders) {
        // if we are not supposed to write the headers then
        // always format the columns
        return {
          shouldFormatColumns: true,
          headers: null
        };
      }
      // if the row is equal to headers dont format
      if (Array.isArray(row) && headers.every(function (header, i) {
        return header === row[i];
      })) {
        return {
          shouldFormatColumns: false,
          headers: headers
        };
      }
      return {
        shouldFormatColumns: true,
        headers: headers
      };
    }
    // todo change this method to unknown[]
  }, {
    key: "gatherColumns",
    value: function gatherColumns(row) {
      if (this.headers === null) {
        throw new Error('Headers is currently null');
      }
      if (!Array.isArray(row)) {
        return this.headers.map(function (header) {
          return row[header];
        });
      }
      if (RowFormatter.isRowHashArray(row)) {
        return this.headers.map(function (header, i) {
          var col = row[i];
          if (col) {
            return col[1];
          }
          return '';
        });
      }
      // if its a one dimensional array and headers were not provided
      // then just return the row
      if (RowFormatter.isRowArray(row) && !this.shouldWriteHeaders) {
        return row;
      }
      return this.headers.map(function (header, i) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return row[i];
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }
      return this._rowTransform(row, cb);
    }
  }, {
    key: "formatColumns",
    value: function formatColumns(columns, isHeadersRow) {
      var _this2 = this;
      var formattedCols = columns.map(function (field, i) {
        return _this2.fieldFormatter.format(field, i, isHeadersRow);
      }).join(this.formatterOptions.delimiter);
      var rowCount = this.rowCount;
      this.rowCount += 1;
      if (rowCount) {
        return [this.formatterOptions.rowDelimiter, formattedCols].join('');
      }
      return formattedCols;
    }
  }], [{
    key: "isRowHashArray",
    value: function isRowHashArray(row) {
      if (Array.isArray(row)) {
        return Array.isArray(row[0]) && row[0].length === 2;
      }
      return false;
    }
  }, {
    key: "isRowArray",
    value: function isRowArray(row) {
      return Array.isArray(row) && !this.isRowHashArray(row);
    }
    // get headers from a row item
  }, {
    key: "gatherHeaders",
    value: function gatherHeaders(row) {
      if (RowFormatter.isRowHashArray(row)) {
        // lets assume a multi-dimesional array with item 0 being the header
        return row.map(function (it) {
          return it[0];
        });
      }
      if (Array.isArray(row)) {
        return row;
      }
      return Object.keys(row);
    }
  }, {
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if ((0, types_1.isSyncTransform)(transformFunction)) {
        return function (row, cb) {
          var transformedRow = null;
          try {
            transformedRow = transformFunction(row);
          } catch (e) {
            return cb(e);
          }
          return cb(null, transformedRow);
        };
      }
      return function (row, cb) {
        transformFunction(row, cb);
      };
    }
  }]);
}();
exports.RowFormatter = RowFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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